// Helper function to build contact URLs
export const buildContactUrl = (
	user?: { firstName: string; lastName: string; email: string },
	additionalQuery?: string
): string => {
	const queryParams = new URLSearchParams()

	// Add user information if available
	if (user?.firstName && user?.lastName) {
		queryParams.set('name', `${user.firstName} ${user.lastName}`)
	}
	if (user?.email) {
		queryParams.set('email', user.email)
	}

	// Add additional query parameter if provided
	if (additionalQuery) {
		queryParams.set('query', additionalQuery)
	}

	const queryString = queryParams.toString()
	return `/support/contact${queryString ? `?${queryString}` : ''}`
}
